<div class="wrapper"
  #content>
  <ng-content></ng-content>
</div>
<cms-crm-field-info-edit *ngIf="content?.children?.length === 0"></cms-crm-field-info-edit>